import { useAccount } from '../hooks/use-account.js';
import { AuthState } from '../state.js';

/**
 *
 * @description A component that conditionally renders children only if a user is logged in
 */ const IsLoggedIn = ({ children  })=>{
    const authState = useAccount();
    const isLoggedIn = authState === AuthState.LoggedIn;
    if (!isLoggedIn) {
        return null;
    }
    return children;
};
var IsLoggedIn$1 = IsLoggedIn;

export { IsLoggedIn$1 as default };
//# sourceMappingURL=IsLoggedIn.js.map
